import React, { useEffect, useState } from 'react'
import './content.css'
import Card from '../card/Card'
import axios from 'axios'
import Loader from '../loader/Loader'

export default function Content() {
    const [internshipData, setInternshipData] = useState([]);
    const [hackathonData, setHackathonData] = useState([]);
    const [eventData, setEventData] = useState([]);
    const [isLoading1, setIsLoading1] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [isLoading3, setIsLoading3] = useState(true);

    const getData = async () => {
        await axios.get('https://winterns-server-aman.onrender.com/api/v1/action/findAll/internshipDetails')
            .then(res => {
                var { data } = res.data;
                if (data.documents.length > 2) {
                    data.documents = data.documents.slice(-3);
                }
                setInternshipData(data.documents);
                setIsLoading1(false);
            })
            .catch(err => {
                console.log(err);
            });

        await axios.get('https://winterns-server-aman.onrender.com/api/v1/action/findAll/hackathonDetails')
            .then(res => {
                var { data } = res.data;
                if (data.documents.length > 2) {
                    data.documents = data.documents.slice(0, 3);
                }
                setHackathonData(data.documents);
                setIsLoading2(false);
            })
            .catch(err => {
                console.log(err);
            });

        await axios.get('https://winterns-server-aman.onrender.com/api/v1/action/findAll/eventDetails')
            .then(res => {
                var { data } = res.data;
                if (data.documents.length > 2) {
                    data.documents = data.documents.slice(0, 3);
                }
                setEventData(data.documents);
                setIsLoading3(false);
            })
            .catch(err => {
                console.log(err);
            });
    }

    useEffect(() => {
        getData();
    });

    return (
        <div className='content-main'>
            <div className='content-heading'><span>Internships</span> <a className='btn' href='/internships'><span>Explore more</span></a></div>
            <div className='content'>
                {internshipData.length === 0 && !isLoading1 ? <div className='not-available'><p>No Internships Available</p></div> : (
                    !isLoading1 ? internshipData.map(card => (
                        <div className='content-card' key={card._id}>
                            <Card details={card} />
                        </div>
                    )) : (
                        <div className="content-loader">
                            <Loader />
                        </div>
                    )
                )}
            </div>
            <div className='content-heading'><span>Hackathons</span> <a className='btn' href='/hackathons'><span>Explore more</span></a></div>
            <div className='content'>
                {hackathonData.length === 0 && !isLoading2 ? <div className='not-available'><p>No Hackathons Available</p></div> : (
                    !isLoading2 ? hackathonData.map(card => (
                        <div className='content-card' key={card._id}>
                            <Card details={card} />
                        </div>
                    )) : (
                        <div className="content-loader">
                            <Loader />
                        </div>
                    )
                )}
            </div>
            <div className='content-heading'><span>Events</span> <a className='btn' href='/events'><span>Explore more</span></a></div>
            <div className='content'>
                {eventData.length === 0 && !isLoading3 ? <div className='not-available'><p>No Events Available</p></div> : (
                    !isLoading3 ? eventData.map(card => (
                        <div className='content-card' key={card._id}>
                            <Card details={card} />
                        </div>
                    )) : (
                        <div className="content-loader">
                            <Loader />
                        </div>
                    )
                )}
            </div>
        </div>
    )
}
